import { getDocs, limit, orderBy, query } from 'firebase/firestore'

import { getDbInstance } from '#firebase/runtime'

import { getSurveyConfigRevisionsRef } from './refs'

export const fetchLatestSurveyConfig = async (): Promise<string> => {
  const db = getDbInstance()
  const revisionsRef = getSurveyConfigRevisionsRef(db)
  const revisionsQuery = query(
    revisionsRef,
    orderBy('createdAt', 'desc'),
    limit(1)
  )
  const snapshot = await getDocs(revisionsQuery)

  if (snapshot.empty) {
    throw new Error('No survey configuration found in Firestore')
  }

  const content = snapshot.docs[0].data()['content']

  if (typeof content !== 'string') {
    throw new Error(
      'Invalid survey configuration: expected "content" field to be a string'
    )
  }

  return content
}
